import { useUrlState } from '../../../hooks/useUrlState';

const DATE_FIELDS = ['next_billing_date_to', 'next_billing_date_from'];
// This hook is suposed to be consumed by components outside of FilterProvider
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function useSubscriptionFilters<FilterType>() {
  return useUrlState<Partial<FilterType>>({}, DATE_FIELDS);
}
